module.exports = __webpack_public_path__ + "img/2.4cf44e89.png";